export const ActionTypes = {
  LOADING: "LOADING_USER_AREA",
  ERROR: "ERROR_USER_AREA",
  SUCCESS: "SUCCESS_USER_AREA",
};
